import Axios from "axios";
import {
    SET_SALES_PROFIT_BASED_COMMISSION_LIST,
    UNSET_SALES_PROFIT_BASED_COMMISSION_LIST,
    SET_EDITING_SALES_PROFIT_BASED_COMMISSION,
    UNSET_EDITING_SALES_PROFIT_BASED_COMMISSION
} from "@/store/mutation-types";
import { saveUpdateProfitBasedCommission, getSalesProfitBasedCommissionList, getSalesProfitBasedCommissionById } from "@/store/api";

const state = {
    getSalesProfitBasedCommissionList: [],
    editingSalesProfitBasedCommission: null,
};

const getters = {
    getSalesProfitBasedCommissionList(state) {
        return state.getSalesProfitBasedCommissionList;
    },
    getEditingSalesProfitBasedCommission(state) {
        return state.editingSalesProfitBasedCommission;
    }
};

const mutations = {
    [SET_SALES_PROFIT_BASED_COMMISSION_LIST](state, data) {
        state.getSalesProfitBasedCommissionList = data;
    },
    [UNSET_SALES_PROFIT_BASED_COMMISSION_LIST](state) {
        state.getSalesProfitBasedCommissionList = [];
    },
    [SET_EDITING_SALES_PROFIT_BASED_COMMISSION](state, data) {
        state.editingSalesProfitBasedCommission = data;
    },
    [UNSET_EDITING_SALES_PROFIT_BASED_COMMISSION](state) {
        state.editingSalesProfitBasedCommission = [];
    }
};

const actions = {
    saveUpdateProfitBasedCommission({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateProfitBasedCommission, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getSalesProfitBasedCommissionList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getSalesProfitBasedCommissionList, { params: data })
                .then(function (response) {
                    commit("SET_SALES_PROFIT_BASED_COMMISSION_LIST", response.data.data);
                    resolve(response.data.data);
                })
                .catch(function (error) {
                    commit("UNSET_SALES_PROFIT_BASED_COMMISSION_LIST");
                    reject(error);
                })
                .then((always) => {});
        });
    },

    getSaleProfitBasedCommissionById({ commit }, data) {
        const getSaleProfitBasedCommission = `${getSalesProfitBasedCommissionById}/${data}`;
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.get(getSaleProfitBasedCommission)
                .then((response) => {
                    resolve(response.data.data);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
